import {
  Facebook01Icon,
  InstagramIcon,
  Linkedin01Icon,
  NewTwitterRectangleIcon
} from '@hugeicons/react'
import _ from 'lodash'


// Social networks rendered as 40x40 tiles; only filled ones show (handoff bloco 2).
const SOCIAL_LINKS = [
  { key: 'instagram', label: 'Instagram', Icon: InstagramIcon },
  { key: 'facebook', label: 'Facebook', Icon: Facebook01Icon },
  { key: 'linkedin', label: 'LinkedIn', Icon: Linkedin01Icon },
  { key: 'x', label: 'X', Icon: NewTwitterRectangleIcon }
]

/**
 * Identity card (handoff bloco 2). Overlaps the banner (-mt-8) with logo, name,
 * headline and social tiles. Compresses the fold so contact actions reach the
 * first screen.
 */
export const PartnerIdentityCard = ({ partner }) => {
  const logoUrl = _.get(partner, 'logo.file.url')
  const social = partner?.meta?.social_media || {}
  const networks = SOCIAL_LINKS.filter(({ key }) => !!social[key])

  return (
    <div className="relative z-[1] -mt-8 rounded-2xl bg-white p-4 shadow-[0_2px_10px_rgba(76,29,149,.07)]">
      <div className="flex items-start gap-3">
        {logoUrl ? (
          <img
            src={logoUrl}
            alt={partner?.name}
            className="h-16 w-16 shrink-0 rounded-2xl border border-brand/10 object-cover object-center"
          />
        ) : (
          <div className="h-16 w-16 shrink-0 rounded-2xl border border-brand/10 bg-brand-light" />
        )}

        <div className="min-w-0 flex-1 pt-0.5">
          <h1 className="m-0 text-xl font-extrabold leading-tight text-gray-900">
            {partner?.name}
          </h1>
          {!!partner?.meta?.headline && (
            <p className="mt-1 mb-0 text-sm leading-snug text-gray-700">
              {partner.meta.headline}
            </p>
          )}
        </div>
      </div>

      {networks.length > 0 && (
        <div className="mt-3.5 flex gap-2">
          {networks.map(({ key, label, Icon }) => (
            <a
              key={key}
              href={social[key]}
              target="_blank"
              rel="noopener noreferrer"
              aria-label={label}
              className="grid h-10 w-10 place-items-center rounded-xl bg-brand-light/60 text-brand no-underline active:scale-95"
            >
              <Icon size={20} variant="stroke" />
            </a>
          ))}
        </div>
      )}
    </div>
  )
}
